import { Link } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';

import { HeaderMobileNavigationButton } from './components/HeaderMobileNavigationButton';
import { Logo } from '../../images/Logo';

export const HeaderMobile = () => {
  return (
    <Flex alignItems='center' justifyContent='space-between' width='100%' p={4} pb={0} pl={5}>
      <Flex gap={8} alignItems='center'>
        <Link to='/'>
          <Logo width={79} />
        </Link>
      </Flex>
      <Flex gap={4}>
        <HeaderMobileNavigationButton />
      </Flex>
    </Flex>
  );
};
